import {detailsNavigationIdsAndValues} from '../pages/DetailsPage/details.config';

export const HotelsGenericEvent = 'HotelsDwebGeneric';
export const LoggedInPriceBenefitLabel = 'Price_benefit';

export const SrpGAEvents = {
  hotelSortByClicked: 'Hotel_Sort_By_clicked',
  hotelSrpModifyClicked: {
    category: 'Hotel_SRP_Modify_Clicked',
    action: {
      locationChanged: 'Location_Changed',
      checkinCheckoutChanged: 'Check_in-Check_out Changed',
      roomGuestsChanged: 'Rooms_Guests Changed',
    },
  },
  hotelSrpFilterClicked: 'Hotel_SRP_Filter_Clicked',
  hotelSrpClicks: 'Hotel_SRP_Clicks',
  loginClickedSrp: 'Login_Clicked_SRP',
  placesuggestClicked: 'placesuggest_clicked',
  placesuggestFilterSelected: 'placesuggest_FilterSelected',
  srpHoverFilterClicked: 'SRP_Hover_Filter_Clicked',
  srpHover: 'SRP_Hover',
  smartengageBanners: 'Smartengage_Banners',
  hotelDealPageClicks: {
    category: 'Hotel_Deal_Page_Clicks',
    action: {
      dealClicked: 'Deal_Clicked',
    },
  },
  performanceMarkers: {
    start: 'srp-hermes-start',
    end: 'srp-hermes-end',
    duration: 'srp-hermes-duration',
  },
};

export const HomePageGAEvents = {
  hotelHomePageClicks: {
    category: 'Hotel_Home_Page_Clicks',
    action: {
      todaysOfferClicked: 'Todays Offer clicked',
      trendingDestinationsClicked: 'Trending_Destinations_Clicked',
      hotelTopNavigation: 'Hotel Top Navigation',
      exploreMoreClicked: 'Explore More Clicked',
    },
  },
  sliderClicks: {
    category: 'Slider_Clicks',
    action: {
      offerSliderClicked: 'Offer_Slider_Clicked',
      recentSearchSliderClicked: 'Recent_Seach_Slider_Clicked',
      segmentSliderClicked: item => `${item}_Slider_Clicked`,
      travelCollectionsSliderClicked: 'Travel_Collections_Slider_Clicked',
    },
  },
  hotelHomePageLocationClicks: {
    category: 'Hotel_Home_Page_Location_Clicks',
    action: {
      recentSearchesClicked: 'Recent Searches clicked',
      locationType: 'Location Type',
      locationClicked: 'Location Clicked',
      paxClicked: 'Pax Clicked',
      searchTap: 'Search Tap',
      calendarClicked: 'Calender clicked',
    },
  },
  popularDestinationsClicked: 'Popular_destinations_clicked',
  travelCollectionsClicked: 'Travel_Collections_Clicked',
  recentlyViewedHotelsClicked: 'Recently_Viewed_Hotels_Clicked',
  segmentHotelsClicked: 'Segment_Hotels_Clicked',
  homepageView: 'Homepage_view',
};

export const SrpSortingGAMap = {
  popularity: 'Most popular',
  priceup: 'Cheapest first',
  pricedown: 'costliest first',
  rating: 'User ratings',
};

export const DetailPageGAEvents = {
  reviewConsumptionCategory: 'Review_Consumption',
  tagUnclicked: 'Tag_Unclicked',
  tagClicked: 'Tag_Clicked',
  seeAllTags: 'See_All_Tags',
  hideTags: 'Hide_Tags',
  sortClicked: 'Sort_Clicked',
  filterClicked: 'Filter_Clicked',
  readMoreReview: 'Read_More_Review',
  reviewImageClicked: 'Image@Review_Clicked',
  paginationClicked: 'Pagination_Clicked',
  performanceMarkers: {
    start: 'details-hermes-start',
    end: 'details-hermes-end',
    duration: 'details-hermes-duration',
  },
};

export const DetailPageQNAGAEvents = {
  qnaConsumptionCategory: 'QnA_Consumption',
  sortApplied: 'Sort_Applied',
  filterApplied: 'Filter_Applied',
  searchBoxClicked: 'SearchBox_Clicked',
  autosuggestionClicked: 'AutoSuggestion_Clicked',
  clearFilter: 'ClearAll@Filter',
  paginationClicked: 'Pagination',

  qnaGenerationCategory: 'QnA_Generation',
  askQuestion: 'Ask_Question',
  answerClicked: 'Answer_Clicked',
  postAnswer: 'Post_Answer',
  reAsk: 'Re-Ask',
};

export const ReviewGAEvents = {
  category_reviewPageClicks: 'Hotel_Review_Page_Clicks',
  action_cancellationPolicy: 'Cancellation Policy',
  action_earlyCheckin: 'Early_checkin',
  action_viewAllOffers: 'View All offer',
  action_offersClicked: 'OffersClicked',
  action_isGoCashActive: 'isGoCashActive',
  action_viewAllAmenities: 'View_all_amenities_clicked',
  action_offerRemoved: 'Offer_removed',
  action_profileTap: 'Profile_Tap',
  action_descblockFailed: 'Descblock failed',
  action_checkoutClicked: 'Checkout_clicked',
  action_loginClicked: 'Login_clicked',
  performanceMarkers: {
    start: 'review-start',
    end: 'review-end',
    duration: 'review-duration',
  },
};

// DETAILS
export const DetailsGAEvents = {
  click: 'Hotel_Detail_Page_Clicks',
};

export const detailsPageClickEventCategoryName = 'Hotel_Detail_Page_Clicks';

export const DetailsGAClickEventActions = {
  // top
  gostaysKnowMoreClick: 'MBG_Clicked',
  addressClick: 'Top_Location_Click',
  topReviewClick: 'Top_Review_Click',

  // Hotel Details Main
  locationInfoViewInMapClick: 'Location_info_top_map',
  whatGuestsLikeClick: 'Guests_Like_Clicked',
  whatYouShouldKnowClick: 'Know_You_Should_Clicked',
  readAllReviewsClick: 'You_Should_Know_ReadAllReviews',
  guestGalleryOpenerClick: 'Guest_images',
  hotelGalleryOpenerClick: 'Hotel_images',
  bigHotelImageGalleryOpenerClick: 'Hotel_main_image',
  signUpPersuasionClick: 'Signup_clicked',
  viewXRoomOptionsClick: 'Room_option_top_clicked',

  soldout: {
    showAlternateDatesClick: 'Soldout_alternate_click',
    showSimilarHotelsClick: 'Soldout_similar_click',
    seeOtherHotelsClick: 'See_other_hotels_click',
    soldOut: 'Sold_out', // with label Voyagerid_Pax_C/I_C/O
  },

  roomSelection: {
    filterClick: 'Bottom_filter_selected', // with label as filter name
    roomImagesClicked: 'Room_images_clicked',
    viewMoreDetailsModalOpenerClick: 'View_more_details_clicked',
    cancellationPolicyModalOpenerClick: 'Cancellation_policy_clicked',
    eMIModalOpenerClick: 'EMI_clicked',
    signUpInPersuasionTextClick: 'Login_Clicked_Room selection', // pending
    selectButtonClick: 'Select_room_clicked',
  },

  amenities: {
    amenitiesViewAllClick: 'Amenities _View_All',
    amenitiesViewLessClick: 'Amenities_View_Less',
  },

  // pending
  viewportVisible: {
    qnA: 'Questions_tapped',
    reviews: 'Reviews_tapped',
    location: 'Location_tapped',
    similarHotels: 'Similar hotels_Scroll',
  },

  locationMap: {
    nearbyPlacesClick: 'Nearby_transit_clicked', // with value 'attraction', 'transit' as label
    actionButton: 'View_map_reset_button', // with value 'Show Map', 'Show More Places' as label
  },

  similarHotelsClicked: 'Similar_hotels_clicked',

  // navigation,
  nav: {
    [detailsNavigationIdsAndValues.amenities.id]: 'Amenities_Clicked',
    // [detailsNavigationIdsAndValues.QnA.id]: 'Question_and_Answers_Clicked',
    // [detailsNavigationIdsAndValues.hotelPolicies.id]: 'Hotel_Policies_Clicked',
    // [detailsNavigationIdsAndValues.similarHotels.id]: 'Similar_Hotels_Clicked',
    [detailsNavigationIdsAndValues.location.id]: 'Location_Clicked',
    // [detailsNavigationIdsAndValues.aboutProperty.id]: 'About_Property_Clicked',
    [detailsNavigationIdsAndValues.rooms.id]: 'Room_Options_Clicked',
  },
};

export const pageViewPerformanceMarkers = {
  start: 'pageView-start',
  end: 'pageView-end',
  duration: 'pageView-duration',
};
